// extracted by mini-css-extract-plugin
module.exports = {"ChartsContainer":"chartscomponent_ChartsContainer__2kTsT","ChartsWrapper":"chartscomponent_ChartsWrapper__OHACY","ChartsTitleWrap":"chartscomponent_ChartsTitleWrap__3nEd8"};